/* global axios */
import ApiClient from '../ApiClient';

// Satisfação (M3): correlação CSAT × assunto.
class SatisfacaoAPI extends ApiClient {
  constructor() {
    super('fandata/satisfacao', { accountScoped: true });
  }

  // T-256: `lado` é 'bira' ou 'humano'; ausente quer dizer a operação inteira.
  // T-252: o canal entra junto do lado.
  get({ since, until, lado, inboxId } = {}) {
    return axios.get(this.url, {
      params: { since, until, lado, inbox_id: inboxId },
    });
  }
}

export default new SatisfacaoAPI();
